import axiosInstance from "./axiosInstance";
import { PlannerOutputViewResponse } from "../types/plannerOutputViewReponse";

export const getPlannerOutputView = async (
  plantId: string
 ): Promise<PlannerOutputViewResponse[]> => {
  const response = await axiosInstance.get<PlannerOutputViewResponse[]>(
    "/api/output-view",
    {
      params: { plantId },
    }
  );

  return response.data;
};
